import styles from './align.module.css';

import type { AlignProps } from './AlignProps';

/**
 * Return the CSS classes to style the alignment of an element.
 *
 * @internal
 */
export function getAlignStyles(props: AlignProps | undefined) {
  const alignStyles: string[] = [];
  let { align } = props || {};
  if (typeof align === 'string') {
    align = { xs: align };
  }

  if (align?.xs) {
    alignStyles.push(styles[`align-${align.xs}`]);
  }

  if (align?.sm) {
    alignStyles.push(styles[`sm-align-${align.sm}`]);
  }

  if (align?.md) {
    alignStyles.push(styles[`md-align-${align.md}`]);
  }

  if (align?.lg) {
    alignStyles.push(styles[`lg-align-${align.lg}`]);
  }

  if (align?.xl) {
    alignStyles.push(styles[`xl-align-${align.xl}`]);
  }

  return alignStyles;
}
